import useLocalStorageState from 'use-local-storage-state';

export function useEntryDraftState() {
  return useLocalStorageState('entryDrafts');
}

export function useCommentDraftState() {
  return useLocalStorageState('commentDrafts');
}
